import { render, staticRenderFns } from "./panel_vaccine.vue?vue&type=template&id=f65b1ff4&scoped=true&"
import script from "./panel_vaccine.vue?vue&type=script&lang=js&"
export * from "./panel_vaccine.vue?vue&type=script&lang=js&"
import style0 from "./panel_vaccine.vue?vue&type=style&index=0&id=f65b1ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65b1ff4",
  null
  
)

export default component.exports